const fontsCss = `@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap');

body {
    -webkit-font-feature-settings: 'lnum';
    -moz-font-feature-settings: 'lnum';
    font-feature-settings: 'lnum';
    * {
        -webkit-font-feature-settings: 'lnum';
        -moz-font-feature-settings: 'lnum';
        font-feature-settings: 'lnum';
    }
}
`;
export {
  fontsCss as default
};
//# sourceMappingURL=fonts.css.js.map
